import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 1024 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 1024,
		height: 1024,
		fill: "#281E38"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M814.704 561.951C790.727 707.809 664.351 818.701 511.5 818.701C342.165 818.701 204.3 681.335 204.3 511.501C204.3 341.666 342.165 204.8 511.5 204.8C663.851 204.8 790.727 316.191 814.704 461.549H739.777C716.799 356.652 623.391 278.228 511.5 278.228C382.626 278.228 278.228 382.626 278.228 511.501C278.228 640.375 382.626 744.773 511.5 744.773C623.391 744.773 716.799 666.349 739.777 561.452H814.704V561.951ZM613.4 561.951C594.919 599.415 556.456 625.389 511.999 625.389C467.543 625.389 429.08 599.415 410.598 561.951H331.176C353.155 640.874 425.584 698.818 511.5 698.818C597.416 698.818 669.845 640.874 691.824 561.951H613.4Z",
		fill: "#00CAAC"
	})]
});
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
